import React from 'react';
import { useDispatch } from 'react-redux';
import { StripSquare } from '../../plot/components/StripSquare';
import { useMovingWindow } from '../../plot/hooks/useMovingWindow';
import { useEventTimestamp } from '../../plot/hooks/useEventTimestamp';
import { startNavigation } from '../thunks/start-navigation.thunk';
import { useTheme } from '@cdl/heartbeat-react';

interface Props {
  duration: number; // ms
}

export const CursorPosition: React.FC<Props> = ({ duration }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const getTimestamp = useEventTimestamp();
  const { start, end } = useMovingWindow(duration);

  return (
    <StripSquare
      onset={start}
      offset={end}
      cursor='move'
      main={{
        style: {
          fill: theme.colors.primary[500],
          opacity: 0.15,
        },
        onMouseDown(event) {
          if (event.defaultPrevented) {
            return;
          }
          event.preventDefault();
          dispatch(startNavigation(getTimestamp(event)));
        },
      }}
    />
  );
};
